/** A run's stored error as staff read it: forun's structured `failure` (code, category,
 * message, hint, step), its free text kept as `step_failed`, or a §8 envelope. */
export type RunFailure = {
  code: string;
  category?: string;
  message?: string;
  hint?: string;
  step?: string;
};

export const FAILURE_CATEGORIES = ['transient', 'data', 'config', 'resources', 'bug'] as const;

const text = (v: unknown): string | undefined => (typeof v === 'string' && v ? v : undefined);

export function runFailure(error: unknown): RunFailure | undefined {
  if (!error || typeof error !== 'object') return undefined;
  const e = error as Record<string, unknown>;
  return {
    code: text(e.code) ?? '',
    category: text(e.category),
    message: text(e.message),
    hint: text(e.hint),
    step: text(e.step),
  };
}

/** Badge colour per failure category; theme colours only. */
export function categoryColor(category: string | undefined): string {
  if (category === 'transient') return 'yellow';
  if (category === 'bug') return 'red';
  return 'gray';
}

/** The first non-empty line of a message, for a one-line summary. */
export function firstLine(message: string | undefined): string {
  return (message ?? '').split('\n').map((l) => l.trim()).find(Boolean) ?? '';
}
